<template>
  <div class="checkup-page pt-3">
    <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
    <Flash v-if="success" :message="success" type="success" v-on:close="success = ''"/>

    <Loader v-if="loading"/>

    <CheckupCalendar
      :catalogs="catalogs"
      :items="items"
      :prescriptions="prescriptions"
      :answers="answers"/>
  </div>
</template>

<script>
import Loader from '../common/Loader';
import Flash from '../common/Flash';
import CheckupCalendar from './checkup/Calendar';

export default {
  name: 'Checkup',

  components: {Loader, Flash, CheckupCalendar},

  props: ['client'],

  data() {
    return {
      loading: true,
      error: '',
      success: '',
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    catalogs() {
      return this.$store.state.checkup.catalogs;
    },

    answers() {
      return this.$store.getters.checkupAnswers(this.client.id);
    },

    prescriptions() {
      return this.$store.getters.checkupPrescriptions(this.client.id);
    },

    items() {
      return this.$store.state.checkup.items;
    },
  },

  methods: {
    async loadData() {
      this.loading = true;

      try {
        await Promise.all([
          this.$store.dispatch('CHECKUP_LOAD_CATALOGS', this.client.id),
          this.$store.dispatch('CHECKUP_LOAD_ITEMS', this.client.id),
          this.$store.dispatch('CHECKUP_LOAD_PRESCRIPTIONS', this.client.id),
          this.$store.dispatch('CHECKUP_LOAD_ANSWERS', this.client.id)
        ]);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },
  },
};
</script>
